import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-basic',
  templateUrl: './basic.component.html',
  styleUrls: ['./basic.component.css']
})
export class BasicComponent implements AfterViewInit, OnDestroy {
  
  datagrid;
  gridId = 'SBGridAreaBasic';
  gridStyle = {
    width: '100%',
    height: '510px'
  };

  listDaeGubun = [
    {"label" : "의류", "value" : "clo"},
    {"label" : "모자", "value" : "hat"}
  ];
  listSex = [
    {"label" : "남자", "value" : "M"},
    {"label" : "여자", "value" : "W"},
    {"label" : "공용", "value" : "A"}
  ];

  listSeason = [
    {"label" : "2021 Spring", "value" : "S"},
    {"label" : "2021 Summer", "value" : "SS"},
    {"label" : "2021 Fall", "value" : "F"},
    {"label" : "2021 Winter", "value" : "W"}
];

  // -----------------------------------------------
  // variable for selected item ( binding variable )
  // -----------------------------------------------
  sBrand = "";
  sStyleNo = "";
  sDaeGubun = "";
  sReqDueDate = "";
  sGiGubun = "";
  sDueDate = "";
  sYear = "";
  sSex = "";
  sObeyGroup = "";
  sSaleCountry = "";
  sSeason = "";
  sManufacture = "";
  sImgSrc = "assets/images/default.png";

  constructor() { }

  ngAfterViewInit() {
    const gridProp = {
      id: 'datagrid',
      parentid: this.gridId,
      jsonref: 'ffData',
      showtotalrows:true,
      explorerbar: 'sortmove',
      usemultisorting: true,
      filtering:true,
      backcoloralternate:"#F0F0F0",
      rowheader: ['seq'],
      rowheadercaption:{ seq : '순서'},
      rowheaderwidth:{ seq : '70' },
      columns: [
        {caption : ['브랜드'],		ref : 'col0',		width : '80px',	style : 'text-align:center',	type : 'output'},
        {caption : ['STYLE No'],	ref : 'col1',			width : '150px',	style : 'text-align:center',	type : 'input'},
        {caption : ['대구분'],		ref : 'col2',			width : '120px',	style : 'text-align:center',	type : 'combo', typeinfo :{ ref : 'ffDaeGubunComboData', displayui : true, label : 'label', value : 'value'}},
        {caption : ['요청납기'],		ref : 'col3',			width : '150px',	style : 'text-align:center',	type : 'datepicker', typeinfo : {calendarui:'ux', dateformat:'yymmdd' , oneclickedit : false},format : {type:'date', rule:'yyyy-mm-dd', origin : 'yyyy-mm-dd' }},
        {caption : ['기획구분'],		ref : 'col4',		width : '100px',	style : 'text-align:center',	type : 'output'},
        {caption : ['협의납기'],	ref : 'col5',			width : '200px',	style : 'text-align:center',	type : 'datepicker', typeinfo : {calendarui:'ux', dateformat:'yymmdd' , oneclickedit : false},format : {type:'date', rule:'yyyy-mm-dd', origin : 'yyyy-mm-dd' }},
        {caption : ['연도'],		 	ref : 'col6',		width : '70px',	style : 'text-align:center',	type : 'input', format : {type:'string', rule:'@ "년"'}},
        {caption : ['성별'],		ref : 'col7',			width : '100px',	style : 'text-align:center',	type : 'combo', typeinfo :{ ref : 'ffSexGubunComboData', displayui : true, label : 'label', value : 'value'}},
        {caption : ['Image'],		ref : 'col8',		width : '100px',	style : 'text-align:center',	type : 'output', hidden: true},
        {caption : ['복종그룹'],   ref : 'col9',		width : '250px',	style : 'text-align:center',	type : 'input'},
        {caption : ['판매국가'],		ref : 'col10',			width : '100px',	style : 'text-align:center',	type : 'output'},
        {caption : ['운영시즌'],		ref : 'col11',			width : '150px',	style : 'text-align:center',	type : 'combo', typeinfo :{ ref : 'ffSaleSeasonComboData', displayui : true, label : 'label', value : 'value'}},
        {caption : ['생산처'],		ref : 'col12',			width : '150px',	style : 'text-align:center',	type : 'input'}
      ]
    };
    // ------------------------
    // Creating SBGrid on div
    // ------------------------
    window['datagrid'] = this.datagrid = _SBGrid.create(gridProp);

    // ------------------------
    // Binding event on SBGrid
    // ------------------------
    this.datagrid.bind('click' , () => { this.gridClick(); });
    this.datagrid.bind('rowchanged' , () => { this.gridRowChanged(); });
  }

  ngOnDestroy() {
    _SBGrid.destroy(this.datagrid.getID());
  }


  showGridData(nRow) {
    if ( nRow < 1 ) {
      return;
    }

    this.sBrand = this.datagrid.getCellData(nRow,1);
    this.sStyleNo = this.datagrid.getCellData(nRow,2);
    this.sDaeGubun = this.datagrid.getCellData(nRow,3);
    this.sReqDueDate = this.datagrid.getCellData(nRow,4);
    this.sGiGubun = this.datagrid.getCellData(nRow,5);
    this.sDueDate = this.datagrid.getCellData(nRow,6);
    this.sYear = this.datagrid.getCellData(nRow,7);
    this.sSex = this.datagrid.getCellData(nRow,8);
    this.sImgSrc = "assets/images/"+this.datagrid.getCellData(nRow,9);
    this.sObeyGroup = this.datagrid.getCellData(nRow,10);
    this.sSaleCountry = this.datagrid.getCellData(nRow,11);
    this.sSeason = this.datagrid.getCellData(nRow,12);
    this.sManufacture = this.datagrid.getCellData(nRow,13);
  }

  gridRowChanged() {
    var nRow = this.datagrid.getRow();
    if ( nRow < 1 ) {
      return;
    }
    this.showGridData(nRow);
  }
  gridClick() {
      var nRow = this.datagrid.getRow();
      if ( nRow < 1 ) {
        return;
      }
      this.showGridData(nRow);
  }

}
